import vhUnit from '../__utils/vhUnit';
import lockScroll from '../__utils/lockScroll';
const $ = jQuery.noConflict();
class Header {
	constructor() {
		this.body = document.body;
		this.header = document.querySelector( '.main-header' );
		this.alertBar = this.header.querySelector( '.alert-bar' );
		this.time = 300;
		this.megaMenuLinks = this.header.querySelectorAll( '.main-header__nav .mega-menu__nav-link' );
		this.megaMenus = this.header.querySelectorAll( '.main-header .mega-menu-wrapper' );
		this.btnMenu = this.header.querySelector( '.btn-hamburger' );
		this.menuMobile = this.header.querySelector( '.main-header__nav-mobile--wrapper' );
		this.menuMobileLinks = this.menuMobile.querySelectorAll( '.mega-menu__nav-link' );
		this.megaMenusMobile = this.menuMobile.querySelectorAll( '.mega-menu-wrapper' );
		this.viewport = window.matchMedia( 'screen and (max-width: 1199px)' );
	}

	init() {
		if ( ! this.header ) {
			return;
		}
		this.btnMenu.addEventListener( 'click', ( e ) => this.toggleMenu( e ) );
		[ ...this.menuMobileLinks ].forEach( ( link ) => {
			link.addEventListener( 'click', ( e ) => this.toggleMobileAccordions( e ) );
		} );
		[ ...this.megaMenuLinks ].forEach( ( link ) => {
			link.addEventListener( 'click', ( e ) => this.toggleMegaMenu( e ) );
		} );
	}

	//ToggleMobileAccordion
	toggleMobileAccordions( e ) {
		e.preventDefault();
		const target = e.currentTarget;
		const menuWrapper = target.parentElement.querySelector( '.mega-menu-wrapper' );

		if ( ! menuWrapper ) {
			return;
		}
		if ( target.classList.contains( 'active' ) && menuWrapper.classList.contains( 'active' ) ) {
			this.closeAccordion( target, menuWrapper );
		} else {
			this.showAccordion( target, menuWrapper );
		}
	}

	showAccordion( target, menuWrapper ) {
		target.classList.add( 'active' );
		$( menuWrapper ).addClass( 'active' ).stop().slideDown( this.time );
	}

	closeAccordion( target, menuWrapper ) {
		target.classList.remove( 'active' );
		$( menuWrapper ).removeClass( 'active' ).stop().slideUp( this.time );
	}

	closeAllAccordions() {
		[ ...this.menuMobileLinks ].forEach( ( el ) => el.classList.remove( 'active' ) );
		[ ...this.megaMenusMobile ].forEach( ( el ) => {
			el.classList.remove( 'active' );
			el.style.display = 'none';
		} );
	}

	//ToggleMobileMenu
	toggleMenu( e ) {
		const el = e.currentTarget;
		if ( el.classList.contains( 'active' ) ) {
			this.closeMenu();
			return;
		}
		this.closeMenu();
		this.openMenu( e );
	}

	openMenu( e ) {
		e.preventDefault();
		vhUnit();
		this.menuMobile.classList.add( 'active' );

		e.currentTarget.classList.add( 'active' );
		this.header.classList.add( 'active' );
		this.body.classList.add( 'overlayed' );
		lockScroll.lock();
	}

	closeMenu() {
		this.menuMobile.classList.remove( 'active' );
		this.btnMenu.classList.remove( 'active' );
		this.header.classList.remove( 'active' );
		this.body.classList.remove( 'overlayed' );
		lockScroll.unlock();
	}

	//toggleDesktopMegaMenu
	toggleMegaMenu( e ) {
		e.preventDefault();
		const target = e.currentTarget;
		const menuWrapper = target.parentElement.querySelector( '.mega-menu-wrapper' );

		if ( ! menuWrapper ) {
			return;
		}
		if ( target.classList.contains( 'active' ) && menuWrapper.classList.contains( 'active' ) ) {
			this.closeMegaMenu();
			return;
		}
		this.closeMegaMenu();
		this.showMegaMenu( target, menuWrapper );
	}

	showMegaMenu( target, menuWrapper ) {
		this.header.classList.add( 'mega-menu-open' );
		target.classList.add( 'active' );
		menuWrapper.classList.add( 'active' );
		lockScroll.lock();
	}

	closeMegaMenu() {
		this.header.classList.remove( 'mega-menu-open' );
		[ ...this.megaMenuLinks ].forEach( ( el ) => el.classList.remove( 'active' ) );
		[ ...this.megaMenus ].forEach( ( el ) => el.classList.remove( 'active' ) );
		lockScroll.unlock();
	}

	// change number of column depending od viewport width
	resizeMegaMenu() {
		if ( ! this.viewport.matches && this.megaMenus ) {
			const classTwoColumn = 'mega-menu-wrapper--two-columns';
			const classOneColumn = 'mega-menu-wrapper--one-column';
			[ ...this.megaMenus ].forEach( ( megaMenu ) => {
				const rect = megaMenu.getBoundingClientRect();
				if ( rect.right > ( window.visualViewport.width - 30 ) ) {
					megaMenu.classList.add( classTwoColumn );
					if ( megaMenu.classList.contains( classTwoColumn ) ) {
						megaMenu.classList.add( classOneColumn );
					}
				}
				if ( ( window.visualViewport.width - rect.left ) > 1050 ) {
					megaMenu.classList.remove( classTwoColumn );
				}
				if ( ( window.visualViewport.width - rect.left ) > 750 ) {
					megaMenu.classList.remove( classOneColumn );
				}
			} );
		}
	}

	hideOutsideClick( e ) {
		if ( ! this.header.contains( e.target ) && ( this.header.classList.contains( 'active' ) || this.header.classList.contains( 'mega-menu-open' ) ) ) {
			if ( this.viewport.matches ) {
				this.closeMenu();
			} else if ( this.header.classList.contains( 'mega-menu-open' ) ) {
				this.closeMegaMenu();
			}
		}
	}

	resized() {
		if ( ! this.header ) {
			return;
		}
		if ( ! this.viewport.matches ) {
			this.closeMenu();
			this.closeAllAccordions();
		} else if ( this.viewport.matches ) {
			if ( this.header.classList.contains( 'mega-menu-open' ) ) {
				this.closeMegaMenu();
			}
		}
		this.resizeMegaMenu();
	}
}

export default new Header();
